import { useMemo } from 'react'
import { useCustomizationStore } from '@/stores/customization/customizationStore'

/**
 * Hook to get launcher preview data from customization store
 * @param {Object} options - Configuration options
 * @param {boolean} options.showBadge - Whether to show the notification badge
 * @param {number} options.badgeCount - Number to display in the badge
 * @param {string} options.size - Tailwind size class for the launcher
 * @returns {Object} Launcher preview props
 */
const useLauncherPreview = ({ 
  showBadge = false, 
  badgeCount = 0, 
  size = 'size-14' 
} = {}) => {
  const { customizationData } = useCustomizationStore()

  return useMemo(() => ({
    launcherBackground: customizationData?.launcher_background_color || '#362B9D',
    launcherIcon: customizationData?.launcher_icon,
    badgeCount,
    showBadge,
    size
  }), [customizationData, badgeCount, showBadge, size])
}

export default useLauncherPreview
